<template>
<div class="jumbotron jumbotron-fluid jumbotron-home">
    <div class="jumbotron-home-insider jumbotron-home-insider-alt with-polygons">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-6 offset-md-3">
                    <h1 class="h1-forms">Logowanie</h1>

                    <form id="f-login" action="POST" @submit.prevent="handleRegisterForm()">
                            <form-input type="email" label="E-mail" name="email" :modelValue="email" v-model="email" :error-messages="errorMessage"></form-input>

                            <form-input type="password" label="Hasło" name="password" :modelValue="password" v-model="password" :error-messages="errorMessage"></form-input>

                        <div class="form-group custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input" id="fl-remme" v-model="remember">
                            <label class="custom-control-label" for="fl-remme">Zapamiętaj mnie</label>
                        </div>

                        <div class="form-group text-center">
                            <vue-simple-spinner v-if="processing"></vue-simple-spinner>
                            <button class="btn btn-primary btn-lg" v-else>Zaloguj</button>
                        </div>

                        <div class="form-links">
                            <a href="/password/reset">Nie pamiętasz hasła?</a>
                            <a href="/rejestracja"><b>Załóż konto</b></a>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>

    <notifications group="foo" />

</div>
</template>
<script>
import FormInput from "./formInput";
import Spinner from 'vue-simple-spinner';

export default {
    props: ['redirect'],

    components: {
        FormInput,
        Spinner,
    },
    data() {
        return {
            email: '',
            password: '',
            remember: '',
            processing: '',
            errorMessage: null,
        }
    },

    methods: {
        handleRegisterForm() {
            axios.post('/api/login', {
                email: this.email,
                password: this.password,
                remember: this.remember
            })
                .then(response => {
                    this.processing = true;
                    window.location.href = this.redirect == '' ? '/' : this.redirect;
                })
                .then(response => {
                    this.processing = false;
                    window.location.href = this.redirect == '' ? '/' : this.redirect;
                })
                .catch(error => {
                    this.errorMessage = error.response.data.errors;
                    this.$notify({
                        'group': 'foo',
                        'type': 'error',
                        'title': error.response.data.message,
                    });
                })
                .then(error => {
                    window.scrollTo(document.querySelector('.error').offsetTop, 0);
                });
        }
    }

}

</script>
